import { I18n } from 'react-redux-i18n';
import DATA_TO_TRANSLATE from '../data/translate';
import USER_DATA from '../data/users';

function orderStatus(status) {
  if (status === DATA_TO_TRANSLATE.orderStatus.CONFIRMED) return I18n.t('approved');
  if (status === DATA_TO_TRANSLATE.orderStatus.PAID) return I18n.t('paid');
  if (status === DATA_TO_TRANSLATE.orderStatus.DELIVERED) return I18n.t('delivered');
  if (status === DATA_TO_TRANSLATE.orderStatus.CANCELED) return I18n.t('canceled');
  if (status === DATA_TO_TRANSLATE.orderStatus.PROCESSED) return I18n.t('processed');
  if (status === DATA_TO_TRANSLATE.orderStatus.FINISHED) return I18n.t('processed');
  if (status === DATA_TO_TRANSLATE.orderStatus.ON_CARRIAGE) return I18n.t('inTransport');
  if (status === DATA_TO_TRANSLATE.orderStatus.INVOICES_ISSUED) return I18n.t('invoice');
  if (status === DATA_TO_TRANSLATE.orderStatus.INVOICES_ISSUED_PARTIALLY) return I18n.t('invoicePartially');

  return status;
}

function paymentType(payment) {
  if (payment === DATA_TO_TRANSLATE.paymentType.CREDIT) return I18n.t('credit');
  if (payment === DATA_TO_TRANSLATE.paymentType.DEBIT) return I18n.t('debit');
  if (payment === DATA_TO_TRANSLATE.paymentType.BANK_SLIP) return I18n.t('bankSlip');
  if (payment === DATA_TO_TRANSLATE.paymentType.BILLING) return I18n.t('billing');
  if (payment === DATA_TO_TRANSLATE.paymentType.ESTIMATE) return I18n.t('estimate');
  if (payment === DATA_TO_TRANSLATE.paymentType.GETNET) return I18n.t('getnetTypeOPayment');
  return payment;
}

function paymentStatus(payment) {
  if (payment === DATA_TO_TRANSLATE.paymentStatus.INDEFINITE) return I18n.t('undefined');
  if (payment === DATA_TO_TRANSLATE.paymentStatus.AUTHORIZED) return I18n.t('authorized');
  if (payment === DATA_TO_TRANSLATE.paymentStatus.NOT_AUTHORIZED) return I18n.t('notAuthorized');
  if (payment === DATA_TO_TRANSLATE.paymentStatus.CANCELED) return I18n.t('canceled');
  if (payment === DATA_TO_TRANSLATE.paymentStatus.CAPTURED) return I18n.t('captured');
  if (payment === DATA_TO_TRANSLATE.paymentStatus.NOT_FINISHED) return I18n.t('notFinalized');

  // PAGSEGURO
  if (payment === DATA_TO_TRANSLATE.paymentStatusPagSeguro.AWAIT_PAYMENT) return I18n.t('awaitPayment');
  if (payment === DATA_TO_TRANSLATE.paymentStatusPagSeguro.PAID) return I18n.t('authorized');
  if (payment === DATA_TO_TRANSLATE.paymentStatusPagSeguro.RETURNED) return I18n.t('notAuthorized');
  if (payment === DATA_TO_TRANSLATE.paymentStatusPagSeguro.CANCELED) return I18n.t('canceled');
  if (payment === DATA_TO_TRANSLATE.paymentStatusPagSeguro.DEBITED) return I18n.t('captured');

  // GETNET
  if (payment === DATA_TO_TRANSLATE.paymentStatusGetnet.APPROVED) return I18n.t('approved3');
  if (payment === DATA_TO_TRANSLATE.paymentStatusGetnet.REJECTED) return I18n.t('refused');

  return payment;
}

function clientPurpose(purpose) {
  if (purpose === DATA_TO_TRANSLATE.purposes.CONSUPTION) return I18n.t('consuption');
  if (purpose === DATA_TO_TRANSLATE.purposes.INDUSTRIALIZATION) return I18n.t('industrialization');
  if (purpose === DATA_TO_TRANSLATE.purposes.RESALE) return I18n.t('resale');
  return purpose;
}

function aproverStatus(status) {
  if (status === DATA_TO_TRANSLATE.approverStatus.APPROVED) return I18n.t('approved');
  if (status === DATA_TO_TRANSLATE.approverStatus.CANCELED) return I18n.t('canceled');
  if (status === DATA_TO_TRANSLATE.approverStatus.OPEN) return I18n.t('open');
  return status;
}

function clientFreight(term) {
  if (term === DATA_TO_TRANSLATE.paymentTerms.CIF) return I18n.t('cif');
  if (term === DATA_TO_TRANSLATE.paymentTerms.FOB) return I18n.t('fob');
  if (term === DATA_TO_TRANSLATE.paymentTerms.CIF_REDISPATCH) return I18n.t('cidRedispatch');
  return term;
}

function userType(type) {
  switch (type) {
    case USER_DATA.type.admin:
      return I18n.t('admin');
    case USER_DATA.type.store:
      return I18n.t('user');
    default:
      return type;
  }
}

function registrationStatus(status, contactInCheckbuy) {
  switch (status) {
    case DATA_TO_TRANSLATE.registrationStatus.CONTACT_IN_CHECKBUY:
      if (contactInCheckbuy) {
        return I18n.t('contactInCheckbuyWithContact');
      }
      break;
    case DATA_TO_TRANSLATE.registrationStatus.SPHERE:
      return I18n.t('clientErrorContactNotRegisteredSphere');
    case DATA_TO_TRANSLATE.registrationStatus.CHECKBUY:
      return I18n.t('clientErrorNotRegisteredCheckbuy');
    case DATA_TO_TRANSLATE.registrationStatus.CONTACT_NOT_IN_CHECKBUY:
      return I18n.t('userErrorNotRegisteredCheckbuy');
    default:
      return status;
  }
}

export default {
  orderStatus,
  paymentType,
  paymentStatus,
  clientPurpose,
  clientFreight,
  userType,
  aproverStatus,
  registrationStatus,
};
